import React from 'react'
import { Link } from 'react-router-dom'

const Sitemap = () => {
  return (
    <>
    

  {/* pagte titile section start  */}
  <section className="page_title_mkp_section">
    <div className="page_ti_overly_mkp_div">
      <div className="container">
        <div className="row">
          {/* col start */}
          <div className="col-xxl-12 colxl-12 col-lg-12 col-sm-12 col-12">
            <div className="page_title_tax_mkp_main_div">
              <div className="page_title_tax_mkp_div">
                <h1> Sitemap</h1>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li>Sitemap</li>
                </ul>
              </div>
            </div>
          </div>
          {/* col end */}
        </div>
      </div>
    </div>
  </section>
  {/* pagte titile section end */}

   {/* sitemap section start */}
<div className="site_section">
  {/* container start */}
  <div className="container">
    {/* row start */}
    <div className="row">
      {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* thermowood collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li><Link to="/hdpe-granules">HDPE Granules</Link>  <span data-bs-toggle="collapse" data-bs-target="#thermowood" aria-expanded="false" aria-controls="thermowood" className="fa fa-angle-down" /></li>
            {/* btn end */}
            {/* thermowood list drop div start */}
            <div className="collapse" id="thermowood">
              <div className="collpase_list_ul_div">
                <ul>
                   <li><Link to="/HDPE-Granules/PE-100-SSBK-Granules"><span className="fa fa-angle-double-right" /> PE 100 SSBK Granules</Link></li>  
                        <li><Link to="/HDPE-Granules/PE-80-SBK-Granules"><span className="fa fa-angle-double-right" /> PE 80 SBK Granules</Link></li>  
                        <li><Link to="/HDPE-Granules/PE-63-BK-Granules"><span className="fa fa-angle-double-right" /> PE 63 BK Granules</Link></li>  
                        <li><Link to="/HDPE-Granules/BD-(Blow-Grade)-Granules"><span className="fa fa-angle-double-right" /> BD (Blow Grade) Granules</Link></li>  
                        <li><Link to="/HDPE-Granules/Natural-Granules"><span className="fa fa-angle-double-right" /> Natural Granules</Link></li>  
                        <li><Link to="/HDPE-Granules/Milky-Granules"><span className="fa fa-angle-double-right" /> Milky Granules</Link></li>  
                        <li><Link to="/HDPE-Granules/SSBL-Blue-Drum-Granules"><span className="fa fa-angle-double-right" /> SSBL Blue Drum Granules</Link></li>  
                        <li><Link to="/HDPE-Granules/Custom-Compounded-Granules"><span className="fa fa-angle-double-right" /> Custom Compounded Granules</Link></li>  
                </ul>
              </div>
            </div>
            {/* thermowood list drop div end */}
          </div>
          {/* thermowood collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}
      {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* flooring collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li><Link to="/lldpe-granules">LLDPE Granules </Link> <span data-bs-toggle="collapse" data-bs-target="#flooring" aria-expanded="false" aria-controls="flooring" className="fa fa-angle-down" /></li>
            {/* btn end */}
            {/* flooring list drop div start */}
            <div className="collapse" id="flooring">
              <div className="collpase_list_ul_div">
                <ul>
                 
                  <li><Link to="/LLDPE-Granules/Cable-Compounding-N1-N2-granules">Cable Compounding N1, N2 granules</Link></li>
                </ul>
              </div>
            </div>
            {/* flooring list drop div end */}
          </div>
          {/* flooring collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}
      {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* ipewood collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li> <Link to="/ppcp-granules">PPCP Granules </Link><span data-bs-toggle="collapse" data-bs-target="#ipewood" aria-expanded="false" aria-controls="ipewood" className="fa fa-angle-down" /></li>
            {/* btn end */}
            {/* ipewood list drop div start */}
            <div className="collapse" id="ipewood">
              <div className="collpase_list_ul_div">
                <ul>
                  <li><Link to="/PPCP-Granules/Black-PPCP-Granules">Black PPCP Granules</Link></li>  
                 <li><Link to="/PPCP-Granules/Natural-PPCP-Granules">Natural PPCP Granules</Link></li>
                </ul>
              </div>
            </div>
            {/* ipewood list drop div end */}
          </div>
          {/* ipewood collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}

      {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* wpc collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li><Link to="/custom-compounding">Custom Compounding </Link> </li>
            {/* btn end */}
           
          </div>
          {/* flooring collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}


      {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* wpc collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li><Link to="/hdpe-dana">HDPE Dana</Link> </li>
            {/* btn end */}
           
          </div>
          {/* flooring collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}

      {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* ipewood collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li> <Link to="/ldpe-granules">LDPE Granules </Link><span data-bs-toggle="collapse" data-bs-target="#ldpe" aria-expanded="false" aria-controls="ldpe" className="fa fa-angle-down" /></li>
            {/* btn end */}
            {/* ldpe list drop div start */}
            <div className="collapse" id="ldpe">
              <div className="collpase_list_ul_div">
                <ul>
                 <li><Link  to="/ldpe-dana">LDPE Dana</Link></li>
                </ul>
              </div>
            </div>
            {/* ipewood list drop div end */}
          </div>
          {/* ipewood collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}

       {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* wpc collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li><Link to="/lldpe-dana">LLDPE Dana</Link> </li>
            {/* btn end */}
           
          </div>
          {/* flooring collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}


       {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* wpc collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li><Link to="/pp-dana">PP Dana</Link> </li>
            {/* btn end */}
           
          </div>
          {/* flooring collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}

         {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* wpc collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li><Link to="/pp-granules">PP Granules</Link> </li>
            {/* btn end */}
           
          </div>
          {/* flooring collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}

      {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* wpc collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li><Link to="/ppcp-dana">PPCP Dana</Link> </li>
            {/* btn end */}
           
          </div>
          {/* flooring collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}

      {/* col start */}
      <div className="col-lg-4 col-md-6 col-sm-12 col-12">
        {/* sitemap main div list div start */}
        <div className="sitemap_main_div_list">
          {/* wpc collapse start */}
          <div className="thermowood_collapse_div">
            {/* btn start */}
            <li><Link to="#">Quick Links </Link> <span data-bs-toggle="collapse" data-bs-target="#Quick" aria-expanded="false" aria-controls="Quick" className="fa fa-angle-down" /></li>
            {/* btn end */}
            {/* Quick list drop div start */}
            <div className="collapse" id="Quick">
              <div className="collpase_list_ul_div">
                <ul>
                  <li><Link to="/about-us">About Us</Link></li>
                  <li><Link to="/epr-services">EPR / Waste Management Service</Link></li>
                  <li><Link to="/contact-us">Contact Us</Link></li>
                </ul>
              </div>
            </div>
            {/* flooring list drop div end */}
          </div>
          {/* flooring collapse end */}
        </div>
        {/* sitemap main div list div end */}
      </div>
      {/* col end */}
    </div>
    {/* row end */}
  </div>
  {/* container end */}
</div>
{/* sitemap section end */}


    </>
  )
}

export default Sitemap
